module.exports = __webpack_public_path__ + "static/img/img_banner.7592ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/img_banner.png
// module id = xmFm
// module chunks = 1